export const breakpoint = '1021px';
export const max_width = '970px';

export const GLOBAL_PREFIX =
  process.env.REACT_APP_GLOBAL_PREFIX ?? `operator/boutique/front`;

  //@ts-ignore
export const BASE_URL =`${process.env.REACT_APP_SERVER_URL}/${GLOBAL_PREFIX}` ?? `http://localhost:8000/${GLOBAL_PREFIX}`;

export const S3_URL = `${process.env.REACT_APP_ASSETS_URL}/`;

export const POST_REQUEST_OPTIONS = {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
};
